import React from "react";
import { OptionContainer, OptionContent, OptionLabel } from "../../../styles";
import { Select } from "@caelor/ui";
import { getOptionsToSelectUsersBy } from "../defaults";
import { useTranslation } from "react-i18next";
import { usePeopleStore } from "../../../../../../../stores/use-people-store";
import useCosmosCollections from "../../../../../../../hooks/use-cosmos-collections";
import GroupPicker from "../../../../../../../components/ui/group-picker/GroupPicker";
import MissingAppPanel from "../../../../../../../components/ui/missing-app-panel/MissingAppPanel";
import { useOpticsStore } from "../../../../../../../stores/use-optics-store";

function Dynamic() {
  const { t } = useTranslation();

  const { data, selectedTab, updateConfigTab } = usePeopleStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const isCosmosInstalled = useOpticsStore((state) => state.isCosmosInstalled);

  const { collections } = useCosmosCollections();

  const SelectUsersByOptions = getOptionsToSelectUsersBy(t);

  return (
    <>
      <OptionContainer direction="column">
        <OptionLabel>{t("select-user-by")}</OptionLabel>
        <OptionContent full>
          <Select
            options={SelectUsersByOptions}
            value={SelectUsersByOptions.find(
              ({ value }) =>
                value === data.config.tabs[selectedTab].useCollections
            )}
            onChange={({ value }) =>
              updateConfigTab({ value: { useCollections: value } })
            }
          />
        </OptionContent>
      </OptionContainer>

      {data.config.tabs[selectedTab].useCollections ? (
        <OptionContainer direction="column">
          <OptionLabel>{t("cosmos-collections")}</OptionLabel>
          {isCosmosInstalled ? (
            <OptionContent full>
              <Select
                placeholder={t("select-collection")}
                value={collections.find(
                  (clc) =>
                    clc.value ===
                    data?.config?.tabs?.[selectedTab]?.selectedCollections?.[0]
                )}
                options={collections}
                onChange={(result) => {
                  if (!result) {
                    return updateConfigTab({
                      value: { selectedCollections: [] },
                    });
                  }
                  return updateConfigTab({
                    value: {
                      selectedCollections: [result.value],
                    },
                  });
                }}
                isClearable
              />
            </OptionContent>
          ) : (
            <MissingAppPanel
              text={t("missing-cosmos-collections")}
              link={
                "https://marketplace.atlassian.com/apps/1230540/cosmos-intranet-for-confluence-free?hosting=cloud&tab=overview"
              }
              linkText={`${t("set-up")} Cosmos`}
            />
          )}
        </OptionContainer>
      ) : (
        <OptionContainer direction="column">
          <OptionLabel>{t("group")}</OptionLabel>
          <OptionContent full>
            <GroupPicker
              initialGroupId={data.config.tabs[selectedTab].group}
              placeholder={t("select-groups")}
              onUpdate={({ id }) => {
                updateConfigTab({ value: { group: id } });
              }}
            />
          </OptionContent>
        </OptionContainer>
      )}
    </>
  );
}

export default Dynamic;
